import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ContactService {
  private baseUrl = 'api/contact';
  constructor(private http: HttpClient) { }

  // The contact endpoint is public and protected server-side by a Cloudflare Turnstile
  // challenge (token carried in the payload) plus rate limiting. No bearer key is sent —
  // the previous EMAIL_KEY was a public value shipped in the bundle and provided no security.
  sendContactEmail(emailData: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/send`, emailData);
  }
}
